import axios from '@/utils/request'
var Qs = require('qs')
// const saleTypes = ['sale', 'both']
// const balanceTypes = ['balance', 'both']
export default {
  saleTypes: ['sale', 'both'],
  balanceTypes: ['balance', 'both'],
  // 2020-08-01
  findByTenantId() {
    return axios.get('/pay-methods/find-by-tenant-id')
  },
  // 2020-12-16
  findByTypes(params) {
    return axios.get('/pay-methods/find-by-types?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2020-08-01
  update(id, params) {
    return axios.put('/pay-methods/' + id, params)
  },
  // 2020-08-01
  insertBatch(params) {
    return axios.post('/pay-methods/insert-batch', params)
  },
  // 2020-08-01
  delete(id) {
    return axios.delete('/pay-methods/' + id)
  }

}

